import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatApiService } from './chat-api.service';
import { ChatMessage } from './chat-message';

@Injectable({ providedIn: 'root' })
export class ChatService {
  constructor(private api: ChatApiService) {}

  sendMessage(message: string, history: ChatMessage[], payload: any): Observable<any> {
    return this.api.send(message, history, payload);
  }
}
